<template>
  <!-- 关于名厨 -->
  <div class="aboutWrapper" style="font-size:16px">
    <div v-wechat-title="$route.meta.title" />
    <div class="about_content_cn">
      <div class="gl_tc">
        <img v-if="language === 'zh'" src="https://img.mingchu.co/Images/zh_cn_logo3.0.png" alt="" class="gl_logo">
        <img v-if="language === 'en'" src="https://img.mingchu.co/Images/en_us_logo3.0.png" alt="" class="gl_logo">
        <img v-if="language === 'fn'" src="https://img.mingchu.co/Images/zh_tw_logo3.0.png" alt="" class="gl_logo">
        <p v-if="version" id="spanversion">版本 v{{ version }}</p>
      </div>
      <div v-if="language === 'zh' || language === 'en'" class="gl_content">
        <p>我们在家依赖父母的饮食教育，在外享受厨师的感官飨宴，受其影响成为对食物或挑剔或随意的下一代饮食文化传承者。</p>
        <p>然而，我们对烹饪艺术的敬畏心是远远不够的。诚如我们总会忽视厨师的存在一般，我们在享受美味的同时，总会忘记：真正懂得美食的是在后厨辛苦工作的厨师们，若非他们掌握高超的烹饪技艺，懂得饮食文化的前世今生，诸多饮食文化早已消失无踪。</p>
        <p>「名厨」尊重厨师的付出与价值，赞颂他们为推动饮食文化与人类文明所作出的贡献，将 “成就卓越厨师” 作为我们的初心和勇气的源泉，而这也是时代进步赋予我们的机遇和担当。</p>
        <p>「名厨」定义厨师的菜品为“作品” ，并赋予其崇高的含义，坚持用“作品”说话，在开放的互联网环境中，给予厨师公平的展现机会。</p>
        <p>为此，我们搭建了以厨师为核心的数字化厨业服务平台，为厨师及整个餐饮行业服务。在这个作品先行的平台上，我们拥抱互联网思维，依托数字化运营，让作品成为对话的开始，用作品孵化厨师成长，令厨师的价值大放异彩。</p>

        <h3>看世界：</h3>
        <p>让厨师快速全面掌握高品质作品创作所必备的专业知识、标准及方法， 以及放眼全球的灵感和资讯。</p>
        <h3>个人名片：</h3>
        <p>让厨师得以专业地呈现作品、有序地管理成果，形成专属于自己的个人品牌。</p>

        <h3>连接与交互：</h3>
        <p>让厨师敢于突破常规、冲破壁垒，平等开放地交流创作心得，释放创作灵感，推动创新。</p>
        <h3>名厨之路：</h3>
        <p>为厨师的作品进阶和厨业的可持续发展提供必要的参考、指引和助益，赋予正向能量。</p>
        <p>十年来，我们与中国厨师结伴同行，以作品为支点，挖掘自身潜力与价值，催化社群活力，充实厨艺内涵。未来，我们更将洞察全球饮食智慧，展现全球美食作品，创造更多机会与可能性，为持续推动厨业有机发展及餐饮文化的进步而倾力前行。</p>
        <h3>「名厨」，把世界带给厨师，也带厨师去看世界。</h3>
      </div>
      <div v-if="language === 'fn'" class="gl_content">
        <p>我們生活飲食習慣的累積，從家庭洗禮到在外餐飲的感官饗宴，其影響堆疊下讓我們成為對飲食或在意或隨意的飲食文化傳承者。</p>
        <p>然而，飲食、烹飪背後涵蓋的文化與技藝底蘊卻常常被遺忘。廚師不僅是端上美味的職人，更是飲食文化的詮釋者、傳承者，在日復一日的餐飲工作中，延續飲食文化。</p>
        <p>因此，「名廚」希望讓更多人了解廚師的付出與價值，以「成就卓越廚師」作為我們的初心和持續下去的動力。</p>
        <p>我們認為廚師的食譜就是作品，賦予含義，用作品闡述，在開放網路平台上給予廚師更多展現機會。</p>
        <p>所以我們建立了以廚師和其作品為核心的數位平台，希望開啟連結，活絡社群，讓廚師價值更被看見。</p>

        <h3>放眼世界：</h3>
        <p>讓廚師快速全面掌握高品質作品創作所必備的專業知識、標準及方法， 放眼全球的靈感和資訊。</p>
        <h3>個人名片：</h3>
        <p>讓廚師可以更專業地呈現作品、有條理地整理資料，打造專屬的個人品牌。</p>

        <h3>互相連結：</h3>
        <p>讓廚師勇於創新，開放地交流創作心得，釋放創作靈感。</p>
        <h3>名廚之路：</h3>
        <p>為廚師的作品進階和職業生涯的發展提供參考、指引和助益。</p>
        <p>以作品為支點，挖掘自身潛力與價值，促使社群活力，充實廚藝內涵。我們將洞察全球飲食脈動，匯集全球美食作品，創造更多機會與可能性，持續推動餐飲產業有機發展及餐飲文化的進步。</p>
        <h3>「名廚」，將世界帶給廚師，帶廚師放眼世界。</h3>
      </div>
      <div class="foot">
        <p style="width: 100%;height: 40px;"><a href="https://beian.miit.gov.cn" target="_blank" style="width: 100%;height: 40px;display: inline-block;text-align: center;color: #8c9bb8; font-size: 14px;">鲁ICP备11033422号-11A</a></p>
        <img src="https://static.mingchu.co/other/foot.png" alt="" class="gl_foot">
      </div>
    </div>
  </div>
</template>

<script>
import '../../style/scss/custom.scss'

import utils from '@/utils/utils'
export default {
  props: {},
  data() {
    return {
      language: '',
      version: ''
    }
  },
  created() {
    this.language = utils.browserLanguage()
    this.version = utils.getQueryVariable('version')
  },
  methods: {
  }
}
</script>
<style lang="scss">
// .gl_logo{
//   width: 10.24rem !important;height: 9.36rem !important;
// }
.foot img {
    width: 104px;
    height: 30px;
}
</style>

